
      // Initialize GA4 only if measurement ID is provided
      window.GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
      if (window.GA_MEASUREMENT_ID && import.meta.env.PROD) {
        // Create gtag script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${window.GA_MEASUREMENT_ID}`;
        document.head.appendChild(script);

        // Initialize dataLayer and gtag function
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', window.GA_MEASUREMENT_ID, {
          send_page_view: false, // Manual page view tracking via React Router
        });
      }

      const IS_PROD = ['https://lordofvenues.com'].includes(location.origin);
      if (IS_PROD) {
        // Microsoft Clarity
        (function (c, l, a, r, i, t, y) {
          c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
          t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
          y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "rzh9oan14n");

        // Google Analytics
        var gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-TBV131P6DW";
        document.head.appendChild(gtagScript);

        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-TBV131P6DW');
      }

      const IS_STAGE = ['https://staging.lordofvenues.com'].includes(location.origin);
      if (IS_STAGE) {
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "u2bqpsnent");
      }
    